import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markNotificationAsRead } from "../../apis";
import { useAuth } from "../auth";

export function useMarkNotificationAsRead() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { mutate, error, status, data } = useMutation({
    mutationFn: (notificationId: string) => {
      const token = user?.accessToken || "";
      return markNotificationAsRead(token, notificationId);
    },
    onSuccess: () => {
      // Invalidate all notification queries to trigger refetch
      // This is more efficient than resetQueries as it preserves existing data
      // until the refetch completes, providing a better UX
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
        exact: false,
      });
    },
  });

  return {
    markAsRead: mutate,
    error,
    status,
    data,
    isPending: status === "pending",
  };
}
